import requestFeatureAccess from 'lumen/utils/hotel-and-market/request-feature-access';
import type { StaffAccessIndicatorProps } from 'shared-react/lumen';

export interface StaffAccessController {
  ajax: { host: string | undefined };
  hotelAndMarketService: {
    hotel: { id: string | null } | null;
    market: { id: string | null } | null;
    user: { id: string | null };
  };
  isDemoMode: boolean;
}

export default function createStaffAccessProps(
  controller: StaffAccessController,
): StaffAccessIndicatorProps {
  return {
    isDemoMode: controller.isDemoMode,
    onRequestAccess: (subscriptionId?: string): void => {
      const { hotel, market, user } = controller.hotelAndMarketService;
      const target: Record<string, string> = market
        ? { market_id: market.id! }
        : { subscription_id: subscriptionId ?? hotel!.id! };

      requestFeatureAccess(controller.ajax.host!, {
        ...target,
        user_id: user.id!,
      });
    },
  };
}
